import { styled } from '@mui/material/styles';
import { Accordion } from '@mui/material';

const StyledAccordion = styled(Accordion)(({ theme }) => ({
  backgroundColor: 'unset',
  backgroundImage: 'unset',
  boxShadow: 'unset',
  borderBottom: `1px solid ${theme.palette.divider[7]}`,
  marginBottom: theme.spacing(2),
  '& .DLAsummary': {
    minHeight: theme.spacing(5),
    padding: 0,
    '& .MuiAccordionSummary-content': {
      margin: theme.spacing(1, 0, 0.75, 0),
    },
  },
}));
export default StyledAccordion;
